import type { IndustrialType } from '@indutrust/shared-model';
import { createCrudEvents } from '@indutrust/shared-util';

/**
 * Events for CRUD operations on IndustrialType entities.
 *
 * Manages the complete lifecycle of industrial type data operations:
 * - loadAll, loadById, add, edit, delete
 * Each operation has request, success, and failure variants.
 *
 * Uses 'shared.industrial-type' as the event source namespace for Redux DevTools debugging.
 *
 * @example
 * const dispatch = injectDispatch(industrialTypeCrudEvents);
 * dispatch.loadAllRequested({ params: {} });
 */
export const industrialTypeCrudEvents =
  createCrudEvents<IndustrialType>('industrial-type');
